import axios from 'axios'

import { API_URL } from './config'

let http = axios.create({ baseURL: API_URL })
export default http

export function authorize(accessToken) {
  http.defaults.headers.common['Authorization'] = accessToken // s`Bearer ${accessToken}`
}

// export function getSchoolPicture(school) {
//   return `${API_URL}/TzbFilesystems/schools/download/${school.slug}.jpg`
// }



// WEBPACK FOOTER //
// ./src/service/http.js